var _path, _path2, _g, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3223 1.95332C1.3223 2.67348 1.75604 3.32283 2.42121 3.5985C3.087 3.87417 3.85269 3.72179 4.36162 3.21218C4.87124 2.7032 5.02361 1.9375 4.74794 1.27176C4.47227 0.606597 3.82293 0.172852 3.10276 0.172852C2.11957 0.172852 1.3223 0.970126 1.3223 1.95332ZM3.91211 1.95332C3.91211 2.28083 3.71483 2.57549 3.41262 2.70131C3.11039 2.8265 2.76201 2.75695 2.53059 2.52554C2.29918 2.29412 2.22962 1.94574 2.35483 1.64351C2.48065 1.34128 2.7753 1.14402 3.10281 1.14402C3.31715 1.14402 3.52329 1.22937 3.67503 1.38111C3.82678 1.53285 3.91211 1.73896 3.91211 1.95332Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91211 1.95332C3.91211 2.28083 3.71483 2.57549 3.41262 2.70131C3.11039 2.8265 2.76201 2.75695 2.53059 2.52554C2.29918 2.29412 2.22962 1.94574 2.35483 1.64351C2.48065 1.34128 2.7753 1.14402 3.10281 1.14402C3.31715 1.14402 3.52329 1.22937 3.67503 1.38111C3.82678 1.53285 3.91211 1.73896 3.91211 1.95332Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7302 7.73392C10.7302 7.01376 10.2965 6.36441 9.6313 6.08874C8.96551 5.81307 8.19981 5.96545 7.69088 6.47506C7.18127 6.98404 7.02889 7.74974 7.30456 8.41548C7.58023 9.08064 8.22958 9.51439 8.94974 9.51439C9.93293 9.51439 10.7302 8.71711 10.7302 7.73392ZM8.14039 7.73392C8.14039 7.40641 8.33767 7.11175 8.63989 6.98594C8.94212 6.86074 9.2905 6.93029 9.52191 7.1617C9.75333 7.39312 9.82288 7.7415 9.69768 8.04373C9.57186 8.34596 9.27721 8.54322 8.94969 8.54322C8.50268 8.54322 8.14039 8.18094 8.14039 7.73392Z",
    fill: "#26282F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7302 7.73392C10.7302 7.01376 10.2965 6.36441 9.6313 6.08874C8.96551 5.81307 8.19981 5.96545 7.69088 6.47506C7.18127 6.98404 7.02889 7.74974 7.30456 8.41548C7.58023 9.08064 8.22958 9.51439 8.94974 9.51439C9.93293 9.51439 10.7302 8.71711 10.7302 7.73392ZM8.14039 7.73392C8.14039 7.40641 8.33767 7.11175 8.63989 6.98594C8.94212 6.86074 9.2905 6.93029 9.52191 7.1617C9.75333 7.39312 9.82288 7.7415 9.69768 8.04373C9.57186 8.34596 9.27721 8.54322 8.94969 8.54322C8.50268 8.54322 8.14039 8.18094 8.14039 7.73392Z",
    fill: "#29292D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14039 7.73392C8.14039 7.40641 8.33767 7.11175 8.63989 6.98594C8.94212 6.86074 9.2905 6.93029 9.52191 7.1617C9.75333 7.39312 9.82288 7.7415 9.69768 8.04373C9.57186 8.34596 9.27721 8.54322 8.94969 8.54322C8.50268 8.54322 8.14039 8.18094 8.14039 7.73392Z",
    fill: "#26282F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14039 7.73392C8.14039 7.40641 8.33767 7.11175 8.63989 6.98594C8.94212 6.86074 9.2905 6.93029 9.52191 7.1617C9.75333 7.39312 9.82288 7.7415 9.69768 8.04373C9.57186 8.34596 9.27721 8.54322 8.94969 8.54322C8.50268 8.54322 8.14039 8.18094 8.14039 7.73392Z",
    fill: "#29292D"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88994 4.95361V6.84234C2.88994 7.77418 3.64534 8.52958 4.57718 8.52958H5.77976M2.88994 4.95361L4.76079 6.54546M2.88994 4.95361L1.07324 6.49939",
    stroke: "black",
    strokeWidth: 1.12482
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38545 4.4917V2.60297C9.38545 1.67114 8.63005 0.915736 7.69821 0.915736H6.49563M9.38545 4.4917L7.5146 2.89985M9.38545 4.4917L11.2021 2.94593",
    stroke: "black",
    strokeWidth: 1.12482
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/SwapIcon.27e61ecfe5df04ccf4adbdc65d7c4210.svg";
export { ForwardRef as ReactComponent };